/** @format */

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "../src/assets/css/style.css";
import "../src/assets/css/default.css";
import "../src/assets/css/custom.css";
// import "../src/assets/js/custom"
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
// React Redux In Set Provider
import { Provider } from "react-redux";
import store from "./Component/store/Provider";

// Connect Axios
import { baseURL, secretKey } from "./util/config";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import Loader from "./util/Loader";
import { CLOSE_LOADER, LOADER_OPEN } from "./Component/store/dialogue/dialogue.type";

// Suppress noisy console.log output in production builds so debug
// statements don't leak to the browser console for admins. console.error
// and console.warn are intentionally left intact for real issues.
if (process.env.NODE_ENV === "production") {
	// eslint-disable-next-line no-console
	console.log = () => {};
	// eslint-disable-next-line no-console
	console.debug = () => {};
	// eslint-disable-next-line no-console
	console.info = () => {};
}

// Default Base URL Join In Axios
axios.defaults.baseURL = baseURL;

// Send the signed httpOnly admin_token cookie on every request so the
// backend can authenticate even when sessionStorage has been cleared.
axios.defaults.withCredentials = true;

// Default Key Join In Axios
axios.defaults.headers.common["key"] = secretKey;

// Restore Authorization header on app boot from sessionStorage so axios
// calls keep working after a page reload (signed httpOnly cookie is the
// fallback, but it can be blocked by third-party cookie restrictions in
// some browsers — having the bearer token avoids spurious 401s that would
// otherwise log the admin out).
try {
	const storedToken = typeof sessionStorage !== "undefined" ? sessionStorage.getItem("token") : null;
	if (storedToken && storedToken !== "null" && storedToken !== "undefined") {
		axios.defaults.headers.common["Authorization"] = storedToken;
	}
} catch (_e) {
	/* sessionStorage may be unavailable in some privacy modes */
}

axios.interceptors.request.use(
	(req) => {
		store.dispatch({ type: LOADER_OPEN });
		return req;
	},
	(error) => {
		console.log(error);
	},
);

axios.interceptors.response.use(
	(res) => {
		store.dispatch({ type: CLOSE_LOADER });
		return res;
	},
	(err) => {
		if (err.message === "Network Error") {
		}
		store.dispatch({ type: CLOSE_LOADER });
		if (err && err.response && err.response.status === 401) {
			// Use require here to avoid a circular import with util/api.js
			try {
				const { noteUnauthorized } = require("./util/api");
				if (typeof noteUnauthorized === "function") noteUnauthorized();
			} catch (e) {
				// fallback: hard redirect
				if (typeof window !== "undefined") window.location.href = "/admin-login";
			}
		}
		return Promise.reject(err);
	},
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	// <React.StrictMode>
	<BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
		<Provider store={store}>
			<App />
			<ToastContainer />
			<Loader />
		</Provider>
	</BrowserRouter>,
	// </React.StrictMode>
);

reportWebVitals();
